import { StaticImageData } from 'next/image';
import { FC, SVGProps } from 'react';

import FurnaceSection from '@/public/img/expert-advice/learning-center-Furnaces.webp';
import HeatPumpsSection from '@/public/img/expert-advice/learning-center-HeatPumps.webp';
import HumiditySection from '@/public/img/expert-advice/learning-center-Humidity.webp';
import AirQualitySection from '@/public/img/expert-advice/learning-center-AirQuality.webp';
import TroubleshootingSection from '@/public/img/expert-advice/learning-center-Troubleshooting.webp';
import AirConditionersSection from '@/public/img/expert-advice/learning-center-AirConditioners.webp';
import {
	IconAir,
	IconBackArrow,
	IconCircleQuestionMark,
	IconFlame,
	IconHeatPump,
	IconHumidity,
	IconSnowflake,
} from '@/components/icons';

export type CategoryProps = {
	_id: number;
	name:
		| 'Air Conditioners'
		| 'Furnaces'
		| 'Heat Pumps'
		| 'Humidity'
		| 'Air Quality'
		| 'Resources'
		| 'Troubleshooting'
		| 'All Categories';
	slug: string;
	icon: FC<SVGProps<SVGSVGElement>>;
	featImg: StaticImageData | null;
};

export const expertAdviceCategories: CategoryProps[] = [
	{
		_id: 1,
		name: 'Heat Pumps',
		slug: '/expert-advice/heat-pumps/',
		icon: IconHeatPump,
		featImg: HeatPumpsSection,
	},
	{
		_id: 2,
		name: 'Air Conditioners',
		slug: '/expert-advice/ac/',
		icon: IconSnowflake,
		featImg: AirConditionersSection,
	},
	{
		_id: 3,
		name: 'Humidity',
		slug: '/expert-advice/humidity/',
		icon: IconHumidity,
		featImg: HumiditySection,
	},
	{
		_id: 4,
		name: 'Air Quality',
		slug: '/expert-advice/air-quality/',
		icon: IconAir,
		featImg: AirQualitySection,
	},
	{
		_id: 5,
		name: 'Troubleshooting',
		slug: '/expert-advice/troubleshooting/',
		icon: IconCircleQuestionMark,
		featImg: TroubleshootingSection,
	},
	{
		_id: 6,
		name: 'Furnaces',
		slug: '/expert-advice/furnaces/',
		icon: IconFlame,
		featImg: FurnaceSection,
	},
	{
		_id: 7,
		name: 'All Categories',
		slug: '/expert-advice/',
		icon: IconBackArrow,
		featImg: null,
	},
];
